interface ScaleFieldProps {
  min: number
  max: number
  value: string
  onChange: (value: string) => void
  etiquetas?: Record<string, string> | null
  vertical?: boolean
}

export function ScaleField({ min, max, value, onChange, etiquetas, vertical }: ScaleFieldProps) {
  const options = []
  for (let i = min; i <= max; i++) {
    options.push(i)
  }

  // Modo vertical: cards completas como en el multi-step Django
  if (vertical) {
    return (
      <div className="space-y-3">
        {options.map((num) => {
          const isSelected = value === String(num)
          const label = etiquetas?.[String(num)]

          return (
            <button
              key={num}
              type="button"
              onClick={() => onChange(String(num))}
              className={`w-full p-2.5 sm:p-4 border-2 rounded-lg text-left transition-all flex items-center ${
                isSelected
                  ? 'border-blue-600 bg-blue-600 text-white'
                  : 'border-gray-200 bg-white hover:border-blue-400'
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full border-2 mr-3 sm:mr-4 font-bold text-sm sm:text-base ${
                isSelected
                  ? 'border-white bg-white/20 text-white'
                  : 'border-gray-300 dark:border-gray-700 text-gray-700'
              }`}>
                {num}
              </div>
              {label && (
                <span className={`font-medium text-sm sm:text-base ${isSelected ? 'text-white' : 'text-gray-800'}`}>
                  {label}
                </span>
              )}
            </button>
          )
        })}
      </div>
    )
  }

  // Modo horizontal: grid de opciones como en el form estándar Django
  return (
    <div className="grid gap-2.5 my-2.5" style={{ gridTemplateColumns: `repeat(${Math.min(options.length, 5)}, 1fr)` }}>
      {options.map((num) => {
        const isSelected = value === String(num)
        const label = etiquetas?.[String(num)]

        return (
          <button
            key={num}
            type="button"
            onClick={() => onChange(String(num))}
            className={`flex flex-col items-center justify-start p-2.5 rounded-lg transition-all cursor-pointer ${
              isSelected ? '' : 'hover:bg-gray-50'
            }`}
          >
            <div className={`w-10 h-10 rounded-full border flex items-center justify-center font-semibold mb-2 flex-shrink-0 transition-all ${
              isSelected
                ? 'bg-[#4285f4] text-white border-[#4285f4]'
                : 'bg-white border-gray-300 dark:border-gray-700 text-gray-700'
            }`}>
              {num}
            </div>
            {label && (
              <span className="text-xs text-center text-gray-500 min-h-[40px] flex items-center justify-center leading-tight break-words">
                {label}
              </span>
            )}
          </button>
        )
      })}
    </div>
  )
}
